@use "variables" as *;

.tooltipDiv {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: $spacing-s;
  text-align: center;
}

.tooltipName {
  font-size: $fontSize-m;
  font-weight: bold;
  white-space: pre-wrap;
}

.tooltipSubtitle {
  font-size: $fontSize-xs;
  font-weight: normal;
  white-space: pre-wrap;
}

.icon {
  font-size: $fontSize-xxl !important;
}
